import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { QuickActionOrigin } from "./QuickActions";
export var QuickActionsHeader = function QuickActionsHeader(_ref) {
  var origin = _ref.origin,
    hideHeader = _ref.hideHeader;
  if (hideHeader) {
    return null;
  }
  if (origin === QuickActionOrigin.SelfServe) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "subheadingSansMedium"
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "92IV0C",
      defaultMessage: [{
        "type": 0,
        "value": "Raccourcis"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "3x"
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "EeT1Ty",
    defaultMessage: [{
      "type": 0,
      "value": "Actions rapides"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }));
};